import * as Globals from "../../globals";
import {createGroup} from "../../utils/threeUtils";
import {buildingGroup} from "../../main";
import {Floor} from "./floor";
import {setObjectLayer} from "../../utils/layerUtils";
import {floorTypes} from "./floorGeneration";
import {createMeshFromShape, createShapeFromPoints} from "../../utils/shapeUtils";
import {basePlateFloorMaterial} from "../../constants/materialConstants";
import {floorGroupName} from "../../constants/nameConstants";

const defaultBasePlateHeight = 0.20; //m - Definition nach Besprechung vom 16.06.23
export class BasePlateFloor extends Floor {
    constructor(includeOutside) {
        super(includeOutside);

        let mesh = createMeshFromShape(createShapeFromPoints(this.floorPoints), {
            depth: defaultBasePlateHeight,
            bevelEnabled: false
        }, basePlateFloorMaterial);
        mesh.name = "floorMesh";
        let floorGroup = createGroup(floorGroupName, buildingGroup);
        floorGroup.addWithUuid(mesh);
        setObjectLayer(floorGroup, Globals.layers.floor, true);
        floorGroup.userData.floor = {
            orientation: this.orientation,
            type: floorTypes.basePlate,
            includeOutside: this.includeOutside
        };
    }
}
